// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'
const initialCommerce = () => {
    const item = window.localStorage.getItem('commerce')
    //** Parse stored json or if none return initialValue
    return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
    name: 'commerce',
    initialState: {
        commerce: initialCommerce()
    },
    reducers: {
        setCommerce: (state, action) => {
            console.log({state: action.payload})
            state.commerce = action.payload
            localStorage.setItem('commerce', JSON.stringify(action.payload))
        }
    }
})

export const { setCommerce } = authSlice.actions

export default authSlice.reducer
